export default __webpack_public_path__ + "static/media/2.aff6d19a.jpg";